import Consts from "@/consts";
import Auth from "@/plugins/auth";

export default {
  data() {
    return {
      appStoredKey: "application",
      teamStoredKey: "team", //pour les paiements,
      isTrainer: false,
      isCoord: false,
      isAdmin: false
    };
  },
  computed: {
    // Pour les forms
    apps() {
      const arr = this.applications;
      arr.shift();
      return arr;
    },
    // Pour les filtres
    applications() {
      return [
        { value: Consts.APPLICATION.ALL, text: "All" },
        { value: Consts.APPLICATION.BEESECURE, text: "BEE SECURE" },
        { value: Consts.APPLICATION.FREELANCES, text: "FREELANCES" }
      ];
    },
    isFreelances() {
      return (
        Auth.user.application == Consts.APPLICATION.ALL ||
        Auth.user.application == Consts.APPLICATION.FREELANCES
      );
    },
    isBeesecure() {
      return (
        Auth.user.application == Consts.APPLICATION.ALL ||
        Auth.user.application == Consts.APPLICATION.BEESECURE
      );
    }
  },
  methods: {
    moneyFormat(val, digits = 2) {
      return new Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR', minimumSignificantDigits: digits}).format(val)
    },
    isAppCoord(o) {
      return (
        Auth.user.role == Consts.COORDINATION &&
        (Auth.user.application == Consts.APPLICATION.ALL ||
          o.application == Auth.user.application)
      );
    },
    getDefaultApp() {
      if (Auth.user.application) {
        return Auth.user.application;
      }

      return Consts.APPLICATION.ALL;
    },
    setStoredApp (v) {
      localStorage.setItem(this.appStoredKey, JSON.stringify(v));
    },
    getStoredApp () {
      const json = JSON.parse(localStorage.getItem(this.appStoredKey));

      if (json || json == Consts.APPLICATION.ALL) {
        return json;
      }

      this.setStoredApp(this.getDefaultApp());
      return this.getDefaultApp();
    },
    setStoredTeam (v) {
      localStorage.setItem(this.teamStoredKey, JSON.stringify(v));
    },
    getStoredTeam () {
      const json = JSON.parse(localStorage.getItem(this.teamStoredKey));

      if (json || json == 0) { //0 = toutes
        return json;
      }

      this.setStoredTeam(0);// toutes
      return 0;
    },
    setStoredObject (key, value) {
      localStorage.setItem(key, JSON.stringify(value));
    },
    getStoredObject (key) {
      const json = JSON.parse(localStorage.getItem(key));

      if (json || json == 0) { //0 = toutes
        return json;
      }

      this.setStoredObject(null);// toutes
      return null;
    },
    isFreelancesObj(o) {
      return o.application == Consts.APPLICATION.FREELANCES;
    },
    loadUser() {
      if (Auth.user.is_admin) {
        this.isAdmin = true;
      }
      if (Auth.user.role == Consts.COORDINATION) {
        this.isCoord = true;
      }
      if (Auth.user.role == Consts.TRAINER) {
        this.isTrainer = true;
      }
    },
    isCandidate(session) {
      // il est candidat pour la session s'il n'a pas de skill pour son topic ou si le skill qu'il détient est candidat
      return  !Auth.user.skills || Auth.user.skills.length == 0 || !(Auth.user.skills.find(s => s.is_enabled && s.topic_id === session.topic_id && s.role !== Consts.SKILL_ROLE.BS_CANDIDATE) !== undefined)
    }
  }
};
